import lowerCase from 'lodash.lowercase';
import upperFirst from 'lodash.upperfirst';

const getParsedEntity = entity => {
  if (entity === 'PublishedYachtPage') return 'Yacht';
  const [, splitted] = entity.split('Published');
  return upperFirst(lowerCase(splitted));
};

export default getParsedEntity;
